import Entity from '../../../../core/domain/entity';
import UniqueEntityID from '../../../../core/domain/unique_entity_id';

export interface GodsonProps {
  dietitianId: string;
  dietitianFullName: string | null;
  createdAt: Date;
  gain: number;
  stripeBalanceId: string;
}

export class GodsonId extends Entity<unknown> {
  private constructor(id?: UniqueEntityID) {
    super(null, id);
  }

  public static create(id?: UniqueEntityID): GodsonId {
    return new GodsonId(id);
  }
}

export class Godson extends Entity<GodsonProps> {
  get godsonId(): GodsonId {
    return GodsonId.create(this.id);
  }

  get dietitianId(): string {
    return this.props.dietitianId;
  }

  get dietitianFullName(): string | null {
    return this.props.dietitianFullName;
  }

  get createdAt(): Date {
    return this.props.createdAt;
  }

  get gain(): number {
    return this.props.gain;
  }

  get stripeBalanceId(): string {
    return this.props.stripeBalanceId;
  }

  private constructor(props: GodsonProps, id?: UniqueEntityID) {
    super(props, id);
  }

  copyWith(props: GodsonProps): Godson {
    return Godson.create(
      {
        ...this.props,
        ...props,
      },
      this.id,
    );
  }

  public static create(props: GodsonProps, id?: UniqueEntityID): Godson {
    return new Godson(props, id);
  }
}
